
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compensation-disclosure",
      function () {
        return require("private-next-pages/compensation-disclosure.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compensation-disclosure"])
      });
    }
  